import { Box, CardMedia } from '@mui/material';
import logo from 'assets/images/logoMini.svg';

export const AuthLogo = () => (
    <Box sx={{ width: '65px', height: '65px', m: '0 auto' }}>
        <CardMedia sx={{ objectFit: 'contain' }} component="img" width="18px" image={logo} alt="alt image" />
    </Box>
);
